import { render, staticRenderFns } from "./PrimaryBtn.vue?vue&type=template&id=bb6f7cec&scoped=true"
import script from "./PrimaryBtn.vue?vue&type=script&lang=js"
export * from "./PrimaryBtn.vue?vue&type=script&lang=js"
import style0 from "./PrimaryBtn.vue?vue&type=style&index=0&id=bb6f7cec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6f7cec",
  null
  
)

export default component.exports